export default [
    {
        path: '/model',
        name: 'model',
        component: () => import('@/views/models/modelList.vue'),
        meta: {
            resource: 'Model',
            action: 'read',
        },
    },

    {
        path: '/model/new',
        name: 'createModel',
        component: () => import('@/views/models/createModel.vue'),
        meta: {
            resource: 'Model',
            action: 'create',
        },
    },
    {
        path: '/model/new/data',
        name: 'createModelData',
        component: () => import('@/views/models/createModelData.vue'),
        props: true,
        meta: {
            resource: 'Model',
            action: 'create',
        },
    },
    {
        path: '/model/:modelId/scenario/:scenarioId/step/:stepId',
        name: 'redirectModelScenarioStep',
        component: () => import('@/views/pages/Redirect.vue')
    },
    {
        path: '/model/:modelId/scenario/:scenarioId/step/:stepId/dimension/:dimId',
        name: 'redirectModelScenarioStep',
        component: () => import('@/views/pages/Redirect.vue')
    },
]
